import {
    shape,
    string,
    number,
    bool,
    arrayOf,
    object,
} from 'prop-types';

export const linksShape = shape({
    deprecation: string,
    href: string,
    hreflang: string,
    media: string,
    rel: string,
    title: string,
    type: string,
});

linksShape.defaultProps = {
    deprecation: null,
    href: null,
    hreflang: null,
    media: null,
    rel: null,
    title: null,
    type: null,
};

export const gradeShape = shape({
    id: number.isRequired,
    name: string.isRequired,
    ordinal: number.isRequired,
});

export const stateShape = shape({
    id: number.isRequired,
    name: string.isRequired,
    ordinal: number.isRequired,
});

export const subjectShape = shape({
    id: number.isRequired,
    name: string.isRequired,
    abbreviation: string.isRequired,
    orderKey: number.isRequired,
    identifier: string.isRequired,
});

export const favoriteShape = shape({
    id: number.isRequired,
    object_id: number.isRequired,
    type: string.isRequired,
    url: string.isRequired,
    user_id: number.isRequired,
    subject: string.isRequired,
});

export const flipbookShape = shape({
    id: object,
    img: string.isRequired,
    title: string.isRequired,
    url: string.isRequired,
});

export const bookShape = shape({
    flipbooks: arrayOf(flipbookShape),
    gradeRegexp: string,
    grades: arrayOf(number),
    title: string,
});

export const courseShape = shape({
    subject_short: string.isRequired,
    starts_at: string.isRequired,
    ends_at: string.isRequired,
    teacher_display_name: string.isRequired,
    bbb_join_link: string.isRequired,
});

export const eventShape = shape({
    id: number,
    title: string.isRequired,
    subject: string.isRequired,
    description: string.isRequired,
    maxParticipants: number,
    isParticipant: bool.isRequired,
    hasAvailableSlot: bool.isRequired,
    start: string,
    end: string,
    color: string.isRequired,
});

export const exerciseShape = shape({
    id: number.isRequired,
    name: string,
    content: string,
    solution: string,
    level: number.isRequired,
});

export const topicShape = shape({
    id: number.isRequired,
    parentId: number,
    canonicalId: number,
    name: string,
    title: string,
    titleSeo: string,
    description: string,
    shortDescription: string,
    abitur: bool,
    keyTopic: bool,
    shortDescriptionSeo: string,
    headline: string,
    subheadline: string,
    page: bool,
    gradeId: number.isRequired,
    subjectId: number.isRequired,
    exercisesCount: number,
    wikisCount: number,
});

export const seoGradesTopicsStructureShape = shape({
    gradeId: number.isRequired,
    gradeName: string.isRequired,
    topics: [{
        topicId: number.isRequired,
        topicName: string.isRequired,
        underTopics: arrayOf(topicShape),
    }],
});

export const videoShape = shape({
    id: number.isRequired,
    nhl: string,
    part: string,
    playoutId: string,
    title: string,
    videoFallbackUrl: string,
    videoId: number,
    videoPreviewImageUrl: string,
    videoUrl: string,
    youtubeId: string,
    lisaVideoFallbackUrl: string,
});

export const centerShape = shape({
    id: number,
    name: string,
    number: number.isRequired,
    franchise: bool,
    links: arrayOf(linksShape).isRequired,
});

export const userShape = shape({
    id: number,
    firstname: string,
    lastname: string,
    email: string,
    typeOfSchool: string,
    classlevel: number,
    birthdate: string,
    isOnlineCustomer: bool,
    subjects: arrayOf(string),
});

export const paymentDetailsShape = shape({
    nextCycleDate: string,
    paymentType: string,
});

export const examShape = shape({
    id: number.isRequired,
    name: string.isRequired,
    category: number,
    links: arrayOf(string),
    exam_id: number.isRequired,
    start_date: string,
    end_date: string,
});

examShape.defaultProps = {
    category: 2,
    links: [],
    end_date: null,
};

// TODO: To be removed when FAQ is refactored
export const contractShape = shape({
    id: number.isRequired,
    name: string.isRequired,
    center: centerShape.isRequired,
    links: arrayOf(linksShape).isRequired,
    icas_contract_id: number.isRequired,
    icas_pupil_id: number.isRequired,
    icas_debitor_id: number.isRequired,
    valid_until: string,
    user_id: number.isRequired,
});

const requestItemCommentsAttachmentsShape = shape({
    content_type: string.isRequired,
    content_url: string.isRequired,
    file_name: string.isRequired,
    id: string.isRequired,
    url: string.isRequired,
});

requestItemCommentsAttachmentsShape.defaultProps = {
    content_type: '',
    content_url: '',
    file_name: '',
    id: '',
    url: '',
};

export const requestItemCommentsShape = shape({
    attachments: arrayOf(requestItemCommentsAttachmentsShape),
    author_id: string,
    body: string,
    created_at: string,
    html_body: string,
    id: string,
    request_id: string,
    type: string,
    url: string,
});

requestItemCommentsShape.defaultProps = {
    attachments: [],
    author_id: '',
    body: '',
    created_at: '',
    html_body: '',
    id: '',
    request_id: '',
    type: '',
    url: '',
};

export const requestItemShape = shape({
    comments: arrayOf(requestItemCommentsShape),
    created_at: string,
    description: string,
    id: string,
    requester_id: string,
    school_class: string,
    school_subject: string,
    status: string,
    subject: string,
    type_of_school: string,
    updated_at: string,
    can_be_solved_by_me: bool,
});

requestItemShape.defaultProps = {
    comments: [],
    created_at: '',
    description: '',
    id: '',
    requester_id: '',
    school_class: '',
    school_subject: '',
    status: '',
    subject: '',
    type_of_school: '',
    updated_at: '',
    can_be_solved_by_me: false,
};

export const getRequestsResponseShape = shape({
    items: arrayOf(requestItemShape),
    items_size: number,
    page: number,
    page_size: number,
    total_items: number,
});

getRequestsResponseShape.defaultProps = {
    items: [],
    items_size: 0,
    page: 0,
    page_size: 0,
    total_items: 0,
};

export const detailedRequestStatusShape = shape({
    requestId: string,
    loading: bool,
    error: bool,
});

detailedRequestStatusShape.defaultProps = {
    requestId: '',
    loading: false,
    error: false,
};

export const requestResultShape = shape({
    id: string,
    requester_id: string,
    url: string,
});

requestResultShape.defaultProps = {
    id: '',
    requester_id: '',
    url: '',
};

export const uploadedFileShape = shape({
    content_type: string,
    content_url: string,
    file_name: string,
    id: number,
    size: number,
});

uploadedFileShape.defaultProps = {
    content_type: '',
    content_url: '',
    file_name: '',
    id: 0,
    size: 0,
};

export const customLinkPropsShape = shape({
    url: string.isRequired,
    label: string,
    ahref: bool,
});
